import React, { useRef, useEffect, useState } from 'react';

const TikTokPlayer = ({ videoId, videoUrl, width, height, onVideoEnd, autoplay, setMediaTime, paused }) => {
  const iframeRef = useRef(null);
  const videoRef = useRef(null);
  const [isPlayerReady, setIsPlayerReady] = useState(false);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {

      if (event.data.type === 'onMute') {
        setIsPlayerReady(true);
      }

       // Video playing -> ready to unmute
       if (event.data.type === "onStateChange" && event.data.value === 1) {
        // Only unmute if autoplay is true
        if (autoplay) {
          unMute();
        }
      }

      if (event.data.type === 'onStateChange' && event.data.value === 0 && onVideoEnd) {
        onVideoEnd()
      }
      if (event.data.type === 'onCurrentTime'  && setMediaTime) {
        setMediaTime(event.data.value.currentTime)
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {

    if (isPlayerReady) {    
      unMute()
    }
  }, [isPlayerReady])

  const unMute = () => {
    if (iframeRef.current?.contentWindow) {
      const post = () => {
        if (!iframeRef.current?.contentWindow) return;
        iframeRef.current.contentWindow.postMessage({
          type: "unMute",
          value: true,
          "x-tiktok-player": true
        }, '*');
      };
  
      post();
      setTimeout(post, 500);
      setTimeout(post, 1000);
    }
  };
  

  useEffect(() => {
    setVideoError(false);
  }, [videoUrl]);

  // Reflect pause/resume from overlay controls (both the <video> and iframe paths)
  useEffect(() => {
    if (videoRef.current) {
      if (paused) {
        videoRef.current.pause();
      } else {
        const p = videoRef.current.play();
        if (p && p.catch) {
          p.catch(() => {});
        }
      }
    }

    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: paused ? "pause" : "play",
          "x-tiktok-player": true,
        },
        "*"
      );
    }
  }, [paused]);

  if (videoUrl && !videoError) {
    return (
      <video
        ref={videoRef}
        autoPlay={autoplay}
        onEnded={onVideoEnd}
        onTimeUpdate={(e) => setMediaTime && setMediaTime(e.target.currentTime)}
        playsInline
        style={{ width, height, objectFit: 'contain' }}
        src={videoUrl.startsWith('http') ? videoUrl : `https://sgp1.digitaloceanspaces.com/saweria-space/${videoUrl}`}
        onError={() => setVideoError(true)}
      />
    );
  }

  return (
      <iframe
        ref={iframeRef}
        height={height}
        width={width}
        src={`https://www.tiktok.com/player/v1/${videoId}?&music_info=0&description=0&autoplay=${autoplay?1:0}&control=0&progress_bar=0&timestamp=0&rel=0&native_context_menu=0`}
        allow="autoplay && fullscreen"
        title="test"
      />
  );
};

export default TikTokPlayer;